import FooterCalloutRepository from "../FooterCalloutRepository"

export default class WhyPodiemFooterCallout extends FooterCalloutRepository {
    static schemaId = "why_us_footerCallout"

    constructor() {
        super(WhyPodiemFooterCallout.schemaId)
    }
}
